/**
 * Internal dependencies
 */
import vd from 'lib/vd';
import setInProgress from './set-in-progress';

export default (id) => (dispatch) => {
	return vd
		.importOperation(id)
		.cancelOperation()
		.then((operation) => {
			dispatch(setInProgress(operation));
			return operation;
		});
};
